import type { OrderStatus } from '../__generated__/OrdersViewQuery.graphql';

/** Terminal outcome segment for the order finish route; derived from schema OrderStatus. */
export type OrderFinishRouteStatus = Extract<
  OrderStatus,
  'FINISHED' | 'FAILED'
>;

export function isOrderFinishRouteStatus(
  s: string | undefined,
): s is OrderFinishRouteStatus {
  return s === 'FINISHED' || s === 'FAILED';
}
